import { render, staticRenderFns } from "./CardDataTable.vue?vue&type=template&id=6e4a693c&scoped=true"
import script from "./CardDataTable.vue?vue&type=script&lang=js"
export * from "./CardDataTable.vue?vue&type=script&lang=js"
import style0 from "./CardDataTable.vue?vue&type=style&index=0&id=6e4a693c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a693c",
  null
  
)

export default component.exports